var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-gauge",style:({
    width: (_vm.size + "px"),
    height: ((_vm.size / 2) + "px")
  })},[_c('div',{staticClass:"steps"},_vm._l((_vm.steps),function(step,index){return _c('span',{key:index,staticClass:"step"},[_vm._v(_vm._s(index))])}),0),_c('span',{staticClass:"gauge"}),_c('small',[_vm._v(_vm._s(_vm.info))]),_c('span',{staticClass:"indicator",style:({ transform: 'rotate('+ _vm.rotate +'deg)'})})])}
var staticRenderFns = []

export { render, staticRenderFns }